export const FETCH_RAPPORTAGE_STATUS = 'FETCH_RAPPORTAGE_STATUS';

export const RAPPORTAGE_STATUS = 'RAPPORTAGE_STATUS';